import {inject, Injectable} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

import {Account} from '../../domain/model/account.model';
import {ACCOUNT_API_REPOSITORY} from '../../domain/tokens/account-api.token';
import {SaveAccountEntriesRequestBuilder} from '../builders/save-account-entries-request.builder';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {AccountEntriesSavedEvent} from '../../../../../shared/application/events/account/account-entries-saved.event';
import {
  AccountEntriesRejectedEvent
} from '../../../../../shared/application/events/account/account-entries-rejected.event';

@Injectable({providedIn: 'root'})
export class SaveAccountEntriesUseCase {
  private readonly accountRepository = inject(ACCOUNT_API_REPOSITORY);
  private readonly requestBuilder = inject(SaveAccountEntriesRequestBuilder);
  private readonly eventBus = inject(EVENT_BUS);

  execute(account: Account): Observable<void> {
    const request = this.requestBuilder.build(account);

    if (!request) {
      return EMPTY;
    }

    return this.accountRepository.saveEntries(request).pipe(
      tap(() => this.eventBus.publish(new AccountEntriesSavedEvent())),
      catchError(err => {
        if ((err as Error)?.message?.includes('409')) {
          this.eventBus.publish(new AccountEntriesRejectedEvent());
        }

        return EMPTY;
      })
    );
  }
}
